
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.interparcel-shipping-calculator').forEach(function (calculator) {
    const input = calculator.querySelector('input');
    const button = calculator.querySelector('button');
    const results = calculator.querySelector('.interparcel-shipping-results');
let requestVersion = 0;
    if (!input || !button || !results) return;

    const endpoint = '/api/2026-10/graphql.json';

    async function shopifyRequest(query, variables) {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query, variables })
      });

      if (!response.ok) throw new Error('Shopify API request failed');

      const data = await response.json();

      if (data.errors?.length) {
        throw new Error(data.errors[0].message);
      }

      return data.data;
    }

    async function calculateShipping() {
        const thisRequest = ++requestVersion;
      const postcode = input.value.trim();
      const productForm = calculator.closest('.product-single')
  ?.querySelector('.product-form');

const variantSelector = productForm
  ?.querySelector('select[name="id"]');

const variantId = variantSelector?.value ||
  calculator.dataset.variantId;
const selectedBundle = document.querySelector(
  'input[name="bundle_quantity"]:checked'
);

const quantity = selectedBundle
  ? Math.max(1, parseInt(selectedBundle.value, 10) || 1)
  : 1;
 if (!/^\d{4}$/.test(postcode)) {
  results.textContent = 'Please enter a valid 4-digit Australian postcode.';
  return;
}

if (!(window.AU_SHIPPING_POSTCODES instanceof Set)) {
  results.textContent = 'Postcode validation is temporarily unavailable. Please try again later.';
  return;
}

if (!window.AU_SHIPPING_POSTCODES.has(postcode)) {
  results.textContent = 'This postcode was not found. Please check your Australian delivery postcode.';
  return;
}

      if (!variantId) {
        results.textContent = 'Unable to identify this product.';
        return;
      }

      button.disabled = true;
      results.textContent = 'Calculating live shipping prices...';

      try {
        const createQuery = `
          mutation CreateShippingCart($variant: ID!) {
            cartCreate(input: {
             lines: [{ merchandiseId: $variant, quantity: ${quantity} }],
              buyerIdentity: {
                countryCode: AU,
                deliveryAddressPreferences: [{
                  deliveryAddress: {
                    country: "AU"
                    zip: "${postcode}"
                  }
                }]
              }
            }) {
              cart { id }
              userErrors { message }
            }
          }
        `;

        const created = await shopifyRequest(createQuery, {
          variant: 'gid://shopify/ProductVariant/' + variantId
        });

        const creation = created.cartCreate;

        if (creation.userErrors.length) {
          throw new Error(creation.userErrors[0].message);
        }

        const cartId = creation.cart.id;

        const rateQuery = `
          query GetCarrierRates($cartId: ID!) {
            cart(id: $cartId) {
              id
              ... @defer {
                deliveryGroups(first: 10, withCarrierRates: true) {
                  nodes {
                    deliveryOptions {
                      title
                      estimatedCost {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
            }
          }
        `;

        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'multipart/mixed; deferSpec=20220824, application/json'
          },
          body: JSON.stringify({
            query: rateQuery,
            variables: { cartId }
          })
        });

        if (!response.ok) {
          throw new Error('Unable to retrieve shipping rates.');
        }

        const raw = await response.text();
        if (thisRequest !== requestVersion) return;

        const matches = [...raw.matchAll(
          /"title"\s*:\s*"([^"]+)"\s*,\s*"estimatedCost"\s*:\s*\{\s*"amount"\s*:\s*"([^"]+)"/g
        )];

        const rates = matches.map(function (match) {
          return {
            title: match[1],
            price: Number(match[2])
          };
        }).filter(function (rate) {
          return Number.isFinite(rate.price);
        });

        if (!rates.length) {
          results.textContent =
            'No shipping rates available for this postcode. Please contact us for a quote.';
          return;
        }

        rates.sort(function (a, b) {
          return a.price - b.price;
        });

        
results.replaceChildren();

const standardRates = rates.filter(function (rate) {
  return !/express/i.test(rate.title);
});

const expressRates = rates.filter(function (rate) {
  return /express/i.test(rate.title);
});

const cheapestStandard = standardRates[0];
const cheapestExpress = expressRates[0];

const summary = document.createElement('div');
summary.style.marginBottom = '12px';

const heading = document.createElement('strong');
heading.textContent = 'Shipping to ' + postcode;
summary.appendChild(heading);

function addRate(label, rate, prominent) {
  if (!rate) return;

  const row = document.createElement('div');
  row.style.display = 'flex';
  row.style.justifyContent = 'space-between';
  row.style.alignItems = 'center';
  row.style.gap = '12px';
  row.style.marginTop = '12px';

  const name = document.createElement('span');
  name.textContent = label;

  const price = document.createElement('strong');

if (/local delivery/i.test(rate.title) && rate.price === 0) {
  price.textContent = 'FREE';
  price.style.color = '#16803c';
} else {
  price.textContent = '$' + rate.price.toFixed(2);
}

  if (prominent) {
    price.style.fontSize = '20px';
  }

  row.appendChild(name);
  row.appendChild(price);
  summary.appendChild(row);
}

addRate(
  cheapestStandard &&
  /local delivery/i.test(cheapestStandard.title) &&
  cheapestStandard.price === 0
    ? 'Free Local Delivery'
    : cheapestStandard.title,
  cheapestStandard,
  true
);
addRate('Express Delivery', cheapestExpress, false);

if (!cheapestStandard && cheapestExpress) {
  addRate('Available Delivery', cheapestExpress, true);
}

results.appendChild(summary);
if (cheapestStandard && /business pallet/i.test(cheapestStandard.title)) {
  const warning = document.createElement('div');

  warning.textContent =
    'Business pallet delivery may require a commercial address with suitable unloading facilities. Residential delivery options may cost more.';

  warning.style.fontSize = '12px';
  warning.style.color = '#8a5a00';
  warning.style.marginTop = '8px';
  warning.style.lineHeight = '1.5';

  results.appendChild(warning);
}
const details = document.createElement('details');
details.style.marginTop = '12px';

const toggle = document.createElement('summary');
toggle.textContent = 'View all ' + rates.length + ' shipping options';
toggle.style.cursor = 'pointer';
toggle.style.color = '#0077b6';
toggle.style.fontWeight = '500';

details.appendChild(toggle);

const list = document.createElement('ul');
list.style.paddingLeft = '18px';
list.style.marginTop = '10px';

rates.forEach(function (rate) {
  const item = document.createElement('li');
  item.textContent = rate.title + ' — $' + rate.price.toFixed(2);
  item.style.marginBottom = '5px';
  list.appendChild(item);
});

details.appendChild(list);
results.appendChild(details);

const note = document.createElement('small');
note.textContent =
  'Calculated for ' + quantity + ' ' +
  (quantity === 1 ? 'item' : 'items') +
  '. Final shipping confirmed at checkout.';
note.style.display = 'block';
note.style.marginTop = '12px';

results.appendChild(note);


      } catch (error) {
        if (thisRequest !== requestVersion) return;
        console.error('Shipping calculator:', error);
        results.textContent =
          'Unable to calculate shipping right now. Please try again or contact us.';
     } finally {
  if (thisRequest === requestVersion) {
    button.disabled = false;
  }
}
    }

    button.addEventListener('click', calculateShipping);
    document.addEventListener('change', function (event) {
  if (event.target.matches('.single-option-selector, select[name="id"]')) {
    requestVersion++;
    results.textContent = '';
    button.disabled = false;
  }
});
    input.addEventListener('input', function () {
  requestVersion++;
  results.textContent = '';
  button.disabled = false;
});
    document.addEventListener('change', function (event) {
  if (event.target.matches('input[name="bundle_quantity"]')) {
    requestVersion++;
    results.textContent = '';

    if (button.disabled) {
      button.disabled = false;
    }
  }
});
  });
});
